export default "__VITE_ASSET__yFOb647K__"